import styled from 'styled-components'

export const Checkbox = styled.div`
  /* Estilo para o container do checkbox personalizado */
  .custom-checkbox-container {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    user-select: none;
    width: 100%;
  }

  /* Esconde o checkbox original */
  .original-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Cria o checkbox personalizado */
  .custom-checkbox {
    position: relative;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 2px solid #ddd;
    border-radius: 3px;
    margin-right: 8px;
  }

  /* Estilo para quando o checkbox estiver marcado */
  .original-checkbox:checked ~ .custom-checkbox {
    background-color: black; /* Cor amarela quando selecionado */
    border-color: black;
  }

  /* Cria o "check" dentro do checkbox quando estiver marcado */
  .custom-checkbox:after {
    content: '';
    position: absolute;
    display: none;
  }

  .original-checkbox:checked ~ .custom-checkbox:after {
    display: block;
  }

  /* Estilo do "check" */
  .custom-checkbox:after {
    left: 3px;
    top: -1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  /* Estilo para o texto da label */
  .checkbox-label {
    margin-left: 4px;
  }
`

export const Placeholder = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease-in-out;
  font-size: 14px;
  color: #999;
  pointer-events: none;
  z-index: 99;

  &.float {
    top: -8px;
    left: 12px;
    background: white;
    padding: 0 4px;
    color: #333;
    z-index: 99;
  }

  .asterisk {
    color: red;
    margin-left: 2px;
  }
`
